export const microservicesUrls = {
  mfLogin: process.env.VUE_APP_SINGLE_LOGIN_URL || 'https://test-login.mercafacil.com:3333/#/',
  externalBI: process.env.VUE_APP_MICRSERVICES_EXTERNAL_BI_HTTP || 'https://external-bi-hotfix-beta.mercafacil.com/graphql',
}

export default {
  install(Vue, { env }) {
    Vue.prototype.$microservicesUrls = Vue.microservicesUrls = microservicesUrls
  },
}
